<script lang="ts" setup>

const props = defineProps<{
  data: string
}>()

function pretify(data) {
  try {
    return JSON.stringify(JSON.parse(data), null, 2)
  } catch (error) {
    return data
  }
}
</script>

<template>
  <div
    class="w-100"
    style="background: #f8f9fa;padding: 15px;border-radius: 10px;"
  >
    <pre>{{ pretify(props.data) }}</pre>
  </div>
</template>
